import { CustomCell, CustomRenderer, drawTextCell, GridCellKind } from '@glideapps/glide-data-grid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { IConnectionCell } from '@/core/models/columns/connection'

import { drawBubbles } from '../helpers/draw-bubble'

export interface CustomConnectionCellProps {
  readonly type: ColumnTypes
  readonly cell: IConnectionCell
}

export type CustomConnectionCell = CustomCell<CustomConnectionCellProps>

const CustomConnectionRenderer: CustomRenderer<CustomConnectionCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is CustomConnectionCell =>
    (cell.data as CustomConnectionCellProps).type === ColumnTypes.Connection,
  draw: (args, cell) => {
    let value = cell.data.cell.value || []

    if (!value || !Array.isArray(value) || value.length === 0) return

    drawBubbles(args, value as readonly string[])
  },
}

export default CustomConnectionRenderer
